import { EscalationType } from '@aloft/toolkit-shared';

import { STOP_AND_CALL_FIELD_NAME } from './consts.ts';

export const getAPIEscalationType = (
  fieldName: STOP_AND_CALL_FIELD_NAME,
  value: any,
): EscalationType => {
  if (fieldName === 'propertyInterest') {
    if (value === 'Leased Fee') {
      return 'leased_fee_property_interest';
    }
    if (value === 'Leasehold') {
      return 'leasehold_property_interest';
    }
  }
  if (fieldName === 'zoningCompliance') {
    if (value === 'Illegal') {
      return 'zoning_compliance_illegal';
    }
    if (value === 'Non-Conforming') {
      return 'zoning_compliance_non_conforming';
    }
  }
  if (fieldName === 'uadCondition') {
    if (value === 5) {
      return 'c5_condition';
    }
    if (value === 6) {
      return 'c6_condition';
    }
  }
  if (fieldName === 'valueTypes') {
    return 'value_subject_to';
  }
  return 'value_subject_to';
};
